import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import Carousel from "../Carousels/Carousel.js";
import "../Book/book.css";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import CloseIcon from "@mui/icons-material/Close";


const Page = React.forwardRef(({ children, className }, ref) => {
	// Déclaration des états pour le contenu, l'affichage des popups, l'image et la vidéo sélectionnées
	const [content, setContent] = useState({ sections: [], images: [], videos: [] });
	const [showImagePopup, setShowImagePopup] = useState(false);
	const [showVideoPopup, setShowVideoPopup] = useState(false);
	const [selectedImage, setSelectedImage] = useState("");
	const [selectedVideo, setSelectedVideo] = useState("");

	// Fonction pour extraire l'ID de la vidéo à partir d'une URL
	const extractVideoId = (embedUrl) => {
		const urlObj = new URL(embedUrl);
		const videoId = urlObj.pathname.split("/").pop();
		return videoId;
	};

	// Utilisation de useEffect pour traiter le contenu HTML à chaque mise à jour de htmlContent
	useEffect(() => {

		// La fonction extractContentFromHTML extrait et nettoie le contenu du HTML
		function extractContentFromHTML(html) {
			const cleanHTML = DOMPurify.sanitize(html);
			const parser = new DOMParser();
			const doc = parser.parseFromString(cleanHTML, "text/html");

			let sections = [];
			const nodes = Array.from(doc.body.childNodes);
			let currentSection = { title: "", text: "" };

			nodes.forEach(node => {
				if (node.nodeName.startsWith("H")) {
					if (currentSection.title || currentSection.text) {
						sections.push(currentSection);
					}
					currentSection = { title: node.textContent, text: "" };
				} else if (node.nodeName === "P") {
					Array.from(node.childNodes).forEach(childNode => {
						// Check if the child node is not an <a> tag
						if (childNode.nodeName !== "A") {
							// Append the text content of the child node to the current section's text
							currentSection.text += childNode.textContent;
						}
					});
				}
			});
			if (currentSection.title || currentSection.text) {
				sections.push(currentSection);
			}

			const images = Array.from(doc.images).map(img => ({
				image: img.src,
				alt: img.alt
			}));

			const videoData = Array.from(doc.querySelectorAll("a[href^=\"https://www.youtube.com/watch\"]")).map(link => {
				const videoUrl = link.href;
				const videoText = link.textContent;
				const urlParams = new URLSearchParams(new URL(videoUrl).search);
				const embedUrl = `https://www.youtube.com/embed/${urlParams.get("v")}`;
				return { embedUrl, videoText };
			});

			return { sections, images, videos: videoData };
		}

		// Extraction du contenu (sections, images, vidéos) et mise à jour de l'état
		const { sections, images, videos } = extractContentFromHTML(children);
		setContent({ sections, images, videos });
	}, [children]);

	// Fonctions pour gérer l'ouverture des popups d'image
	const openImagePopup = (image) => {
		setSelectedImage(image);
		setShowImagePopup(true);
	};

	// Fonctions pour gérer la fermeture des popups d'image
	const closeImagePopup = () => setShowImagePopup(false);

	// Fonctions pour gérer l'ouverture des popups de vidéo
	const openVideoPopup = (src) => {
		setSelectedVideo(src);
		setShowVideoPopup(true);

	};

	// Fonctions pour gérer la fermeture des popups de vidéo
	const closeVideoPopup = () => setShowVideoPopup(false);

	return (
		<div className={className} ref={ref}>
			<div className="book-page-content">
				{content.sections.map(({ title, text }, index) => (
					<div key={index}>
						<h2 >{title}</h2>
						<p>{text}</p>
					</div>
				))}

				<Carousel
					classname={"content"}
					items={content.images.map((image, index) => (
						<div className="image-container" key={index}>
							<img
								src={image.image}
								alt={image.alt}
								onClick={() => openImagePopup(image)}
							/>
						</div>
					))}
					nbItemsToDisplay={1} />

				<Carousel
					classname={"content"}
					items={content.videos.map(({ embedUrl, videoText }, index) => (
						<>
							<div key={index} className="video-container">

								<img
									src={`https://img.youtube.com/vi/${extractVideoId(embedUrl)}/0.jpg`}
									onClick={() => openVideoPopup(embedUrl)}
									alt={""}
								/>
								<PlayCircleIcon className="play-icon" style={{ fontSize: 35 }} />
							</div>
							<p className={"content-description"}>{videoText}</p>
						</>))}
					nbItemsToDisplay={1} />

				{showImagePopup && (
					<div className="popup" onClick={closeImagePopup}>
						<div className="popup-content" onClick={(e) => e.stopPropagation()}>
							<button className="popup-close-button" onClick={closeImagePopup}><CloseIcon style={{ fontSize: 30 }} /></button>
							<TransformWrapper>
								<TransformComponent>
									<img src={selectedImage.image} alt="Popup" />
								</TransformComponent>
							</TransformWrapper>
							<p className="image-description">{selectedImage.alt}</p>
						</div>
					</div>
				)}

				{showVideoPopup && (
					<div className="popup" onClick={closeVideoPopup}>
						<div className="popup-content" onClick={(e) => e.stopPropagation()}>
							<button className="popup-close-button" onClick={closeVideoPopup}><CloseIcon style={{ fontSize: 30 }} /></button>
							<iframe src={selectedVideo} frameBorder="0" allowFullScreen title="Video popup"></iframe>
						</div>
					</div>
				)}
			</div>
		</div >
	);

});

Page.displayName = "Page";

export default Page;